import { useSelector } from 'react-redux';
import { DIALOG_TYPES } from '../../store/dialog/dialog.reducer';
import {
    selectDialogType,
    selectInputData,
} from '../../store/dialog/dialog.selector';
import Dialog from '../ui/dialog/dialog.component';
import DialogRejectAttachment from './dialog-reject-attachment/dialog-reject-attachment.component';
import DialogReplaceAttachment from './dialog-replace-attachment/dialog-replace-attachment.component';
import DialogSelectAttachmentAction from './dialog-select-attachment-action/dialog-select-attachment-action.component';
import DialogSelectProject from './dialog-select-project/dialog-select-project.component';
import DialogShareScene3d from './dialog-share-scene-3d/dialog-share-scene-3d.component';
import DialogCompleteNode from './dialog-complete-node/dialog-complete-node.component';
import DialogNextStep from './dialog-next-step/dialog-next-step.component';

const DialogWrapper = () => {
    const dialogType = useSelector(selectDialogType);
    const inputData = useSelector(selectInputData);

    return (
        <Dialog>
            {dialogType === DIALOG_TYPES.SELECT_PROJECT && (
                <DialogSelectProject />
            )}
            {dialogType === DIALOG_TYPES.SELECT_ATTACHMENT_ACTION && (
                <DialogSelectAttachmentAction inputData={inputData} />
            )}
            {dialogType === DIALOG_TYPES.REJECT_ATTACHMENT && (
                <DialogRejectAttachment inputData={inputData} />
            )}
            {dialogType === DIALOG_TYPES.REPLACE_ATTACHMENT && (
                <DialogReplaceAttachment inputData={inputData} />
            )}
            {dialogType === DIALOG_TYPES.SHARE_SCENE_3D && (
                <DialogShareScene3d inputData={inputData} />
            )}
            {dialogType === DIALOG_TYPES.COMPLETE_NODE && (
                <DialogCompleteNode inputData={inputData} />
            )}
            {dialogType === DIALOG_TYPES.NEXT_STEP_NODE && (
                <DialogNextStep inputData={inputData} />
            )}
        </Dialog>
    );
};

export default DialogWrapper;
